// extracted by mini-css-extract-plugin
export default {"relap-block":"+O5fi"};